"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAffordableNonFederalWagesData = exports.affordableNonFederalWagesFormRules = exports.affordableNonFederalWagesSchema = void 0;
const amount_utils_1 = require("../../amount-utils");
const converters_1 = require("../../converters");
const income_1 = require("./income");
const validateHourPerWeek = (value) => {
    if (value !== undefined && value !== null && value !== '') {
        const numValue = (0, amount_utils_1.parseAmount)(value);
        return numValue > 0 && numValue <= 168;
    }
    return true;
};
const validateWeekPerYear = (value) => {
    if (value !== undefined && value !== null && value !== '') {
        const numValue = (0, amount_utils_1.parseAmount)(value);
        return numValue > 0 && numValue <= 52;
    }
    return true;
};
const validateHourlyWage = (value) => {
    if (value !== undefined && value !== null && value !== '') {
        const numValue = (0, amount_utils_1.parseAmount)(value);
        return numValue > 0;
    }
    return true;
};
const validatePositiveAmount = (value) => {
    if (value !== undefined && value !== null && value !== '') {
        const numValue = (0, amount_utils_1.parseAmount)(value);
        return numValue > 0;
    }
    return true;
};
const validateFrequency = (value) => {
    return value !== undefined && value !== null && value !== '';
};
exports.affordableNonFederalWagesSchema = {
    fields: {
        ...income_1.incomeSchema.fields,
        hour_per_week: {
            required: false,
            custom: {
                validate: validateHourPerWeek,
                message: 'Hours per week must be between 1 and 168',
            },
        },
        week_per_year: {
            required: false,
            custom: {
                validate: validateWeekPerYear,
                message: 'Weeks per year must be between 1 and 52',
            },
        },
        hourly_wage: {
            required: false,
            custom: {
                validate: validateHourlyWage,
                message: 'Hourly wage must be greater than 0',
            },
        },
        member_receives_overtime_pay: {
            required: true,
            pattern: /^(1|0)$/,
        },
        member_receives_bonuses: {
            required: true,
            pattern: /^(1|0)$/,
        },
        member_receives_tips: {
            required: true,
            pattern: /^(1|0)$/,
        },
        overtime_wage: {
            required: false,
            crossFieldValidation: {
                dependentFields: ['member_receives_overtime_pay'],
                validate: (value, allValues) => {
                    if (allValues.member_receives_overtime_pay === '1') {
                        return (validatePositiveAmount(value) ||
                            'Overtime wage is required and must be greater than 0');
                    }
                    return true;
                },
            },
        },
        overtime_hours_per_week: {
            required: false,
            crossFieldValidation: {
                dependentFields: ['member_receives_overtime_pay'],
                validate: (value, allValues) => {
                    if (allValues.member_receives_overtime_pay === '1') {
                        return (validateHourPerWeek(value) || 'Overtime hours per week must be between 1 and 168');
                    }
                    return true;
                },
            },
        },
        overtime_weeks_per_year: {
            required: false,
            crossFieldValidation: {
                dependentFields: ['member_receives_overtime_pay'],
                validate: (value, allValues) => {
                    if (allValues.member_receives_overtime_pay === '1') {
                        return validateWeekPerYear(value) || 'Overtime weeks per year must be between 1 and 52';
                    }
                    return true;
                },
            },
        },
        bonus_amount: {
            required: false,
            crossFieldValidation: {
                dependentFields: ['member_receives_bonuses'],
                validate: (value, allValues) => {
                    if (allValues.member_receives_bonuses === '1') {
                        return (validatePositiveAmount(value) || 'Bonus amount is required and must be greater than 0');
                    }
                    return true;
                },
            },
        },
        frequency_of_bonuses: {
            required: false,
            crossFieldValidation: {
                dependentFields: ['member_receives_bonuses'],
                validate: (value, allValues) => {
                    if (allValues.member_receives_bonuses === '1') {
                        return validateFrequency(value) || 'Frequency of bonuses is required';
                    }
                    return true;
                },
            },
        },
        tip_amount: {
            required: false,
            crossFieldValidation: {
                dependentFields: ['member_receives_tips'],
                validate: (value, allValues) => {
                    if (allValues.member_receives_tips === '1') {
                        return (validatePositiveAmount(value) || 'Tips amount is required and must be greater than 0');
                    }
                    return true;
                },
            },
        },
        frequency_of_tips: {
            required: false,
            crossFieldValidation: {
                dependentFields: ['member_receives_tips'],
                validate: (value, allValues) => {
                    if (allValues.member_receives_tips === '1') {
                        return validateFrequency(value) || 'Frequency of tips is required';
                    }
                    return true;
                },
            },
        },
    },
    messages: {
        ...income_1.incomeSchema.messages,
        institution_name: {
            maxLength: 'Income Source must be 200 characters or less',
        },
        contact_name: {
            maxLength: 'Contact Name must be 50 character or less',
        },
        amount: {
            required: 'Salary/Wage is required',
            min: 'Salary/Wage must be greater than 0',
        },
        overtime_wage: {
            required: 'Overtime Wage is required',
            min: 'Overtime Wage must be greater than 0',
        },
        overtime_hours_per_week: {
            required: 'Overtime Hours Per Week is required',
            min: 'Overtime Hours Per Week must be greater than 0',
        },
        overtime_weeks_per_year: {
            required: 'Overtime Weeks Per Year is required',
            min: 'Overtime Weeks Per Year must be greater than 0',
        },
        bonus_amount: {
            required: 'Bonus Amount is required',
            min: 'Bonus Amount must be greater than 0',
        },
        frequency_of_bonuses: {
            required: 'Frequency of Bonuses is required',
        },
        tip_amount: {
            required: 'Tips Amount is required',
            min: 'Tips Amount must be greater than 0',
        },
        frequency_of_tips: {
            required: 'Frequency of Tips is required',
        },
        member_receives_overtime_pay: {
            required: 'Member Receives Overtime Pay is required',
        },
        member_receives_bonuses: {
            required: 'Member Receives Bonuses is required',
        },
        member_receives_tips: {
            required: 'Member Receives Tips is required',
        },
    },
};
// 🚀 Pre-computed validations for performance
exports.affordableNonFederalWagesFormRules = (0, converters_1.toReactHookForm)(exports.affordableNonFederalWagesSchema, income_1.incomeFieldMapping);
exports.validateAffordableNonFederalWagesData = (0, converters_1.createValidator)(exports.affordableNonFederalWagesSchema);
